import { getFeatureFlagFilter } from '@ApplicationWide/feature-flags';

export const filterRoutes = (routes, featureFlags) => routes.filter(getFeatureFlagFilter(featureFlags));
